/* global VeloxWebView, VeloxViewController, VeloxDatabaseClient */
var uuid = require("uuid") ;
var pkg = require("../../../package.json") ;

var LoginController = VeloxViewController.create({
    directory : "views/login",
    name: "login",
    container: "main",
    noRouting: true
}) ;

LoginController.prototype.prepareDataOnEnter = function(data, callback){
    //normal login
    
    var lastUser = localStorage.getItem("last_user")  ;
    var lastPassword = localStorage.getItem("last_password")  ;

    callback(null, {
        lang: VeloxWebView.i18n.getLang() ,
        connectLogin: lastUser?JSON.parse(lastUser).login:"",
        connectPassword: lastPassword?lastPassword:"",
        rememberPassword: lastPassword?true:false,
    });
};

LoginController.prototype.onLang = function(){
    this.view.updateData(); 
    VeloxWebView.i18n.setLang(this.data.lang) ;
} ;

LoginController.prototype.focusLogin = function(){
    this.view.focusLogin() ;
};

LoginController.prototype.onConnect = function(){
    this.view.longTask(function(done){
        this.api.ping.pong(function(err){
            if(err){
                console.log("can't reach server, refrehs to offline mode") ;
                window.location.reload() ;
                return;
            }
            done() ;
        }.bind(this));
    }.bind(this), function(){
        this.view.updateData(); 
        this.data.error = "" ;
        var errors = [] ;
        if(!this.data.connectLogin){
            errors.push(this.view.tr("login.pleaseInputLogin")) ;
        }
        if(!this.data.connectPassword){
            errors.push(this.view.tr("login.pleaseInputPassword")) ;
        }
        if(errors.length>0){
            this.data.error = errors.join("<br/>") ;
            return this.view.reload() ;
        }
        this.view.longTask(function(done){
            this._doConnect(this.data.connectLogin, this.data.connectPassword, this.data.rememberPassword, done) ;
        }.bind(this)) ;
    }.bind(this));

} ;

LoginController.prototype.onForgotPassword = function(){
    var viewForgot = new VeloxWebView("views/login", "renewPassword") ;
    viewForgot.openInPopup({
        title: " "
    })  ;

    viewForgot.on("validate",function(){
        var userEmail = viewForgot.getData().user.email ;


        var baseUrl = pkg.serverUrl ;

        if(process.env.MODE !== "production"){
            baseUrl = pkg.serverDev ;
            if(process.env.MODE === "test"){
                baseUrl = pkg.serverTest ;
            } else {
                if(process.env.DEVICE === "mobile"){
                    baseUrl = pkg.serverDevMobile ;
                }
            }
        }

        this.view.longTask(function(done){
            var emailRecord = {
                uid: uuid.v4(),
                server_uid: "noreply", 
                from_addr: "noreply@bayrolsolution.com", 
                subject: VeloxWebView.tr("login.renewPasswordSubject"),
                text: VeloxWebView.tr("login.renewPasswordMessage", {link: baseUrl+"/goto?u="+encodeURIComponent("/#renewpass$__activation_token__"), login: "__login__" }),
                html: VeloxWebView.tr("login.renewPasswordMessage", {link: baseUrl+"/goto?u="+encodeURIComponent("/#renewpass$__activation_token__"), login: "__login__" }),
                status: "tosend",
                schedule_type: "now",
                
            };

            this.api.requestPasswordToken(userEmail, emailRecord, function(err){
                if(err) { return done(err) ;}
                viewForgot.close() ;
                VeloxWebView.info(VeloxWebView.tr("login.reinitCheckMail")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

LoginController.prototype._doConnect = function(connectLogin, connectPassword, rememberPassword, callback){
    this.api.auth.user(connectLogin, connectPassword, function(err){
        if(err){
            if(err === "Unauthorized"){
                this.data.error = this.view.tr("login.cantLogin") ;
            }else{
                this.data.error = this.view.tr("login.cantConnectToServer") ;
            }
            this.view.reload() ;
            return callback() ;
        }
        //login OK

        localStorage.setItem("last_user", JSON.stringify(this.api.currentUser)) ;
        if(rememberPassword){
            localStorage.setItem("last_password", connectPassword) ;
        }else{
            localStorage.removeItem("last_password") ;
        }

        require("../../util/resellerInit")(this.api, function(err){
            if(err){
                this.data.error = this.view.tr("login.cantInitAccount") ;
                this.view.reload() ;
                return callback() ;
            }
            this.view.reload() ; 
        
            this.navigate("/") ;
            window.location.reload() ;
            return callback() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = new LoginController() ;